export const SHOW_OPM_CALCULATIONS_TOOLTIP = 'Show OPM Calculations';

export const SHOW_OPM_CALCULATIONS_TEST_ID = 'show-opm-calculations-link';
